import {useEffect, useMemo, useState, useRef} from 'react';
import Helmet from 'react-helmet';
import {DYNAMIC_TAG_LIST} from '@/constants/common/dynamic-tag';
import {
  SEO_TITLE,
  SEO_KEYWORD,
  SEO_DESCRIPTION,
} from '@/constants/common/seo.js';
import useDirectoryStore from '@/stores/directory';
import globalDomains from '@/utils/global-domains';

const HelmetLoader = ({routeName, search}) => {
  const [isRender, setIsRender] = useState(false);
  const loadedScriptsRef = useRef(new Set());
  const {categoryMenu} = useDirectoryStore();
  const url = search.substring(1).split(/[?&=]/);

  const obj = {};

  url.forEach((item) => {
    if (item !== '') {
      const [key, value] = item.split('=');
      obj[key] = value;
    }
  });

  const route = routeName.toString().split('/');
  const routeList = useMemo(() => {
    return [route[1], route[route.length - 1]];
  }, [route]);

  const helmetKeyword = useMemo(() => {
    try {
      if (routeList[0] === 'search') {
        return url[1] === 'hashtag'
          ? SEO_KEYWORD['tagSearch']
          : SEO_KEYWORD['totalSearch'];
      }
      return SEO_KEYWORD[routeList[0]];
    } catch (error) {
      return 'SOOP';
    }
  }, [routeList]);

  const helmetDescription = useMemo(() => {
    try {
      if (routeList[0] === 'directory' || routeList[0] === 'help') {
        return SEO_DESCRIPTION[routeList[0]];
      }
      if (routeList[0] === 'search') {
        return url[1] === 'hashtag'
          ? SEO_DESCRIPTION['tagSearch']
          : SEO_DESCRIPTION['totalSearch'];
      }
      return SEO_DESCRIPTION[routeList[1]];
    } catch (error) {
      return 'SOOP';
    }
  }, [routeList]);

  const helmetTitle = useMemo(() => {
    try {
      if (routeList[0] === 'help') {
        return `${SEO_TITLE[routeList[0]] || ''}SOOP`;
      }

      if (routeList[0] === 'directory') {
        if (route.length === 5) {
          const categoryName = decodeURI(decodeURIComponent(route[3]));

          const currentAdminMenu = categoryMenu.find((v) => {
            return v.menuId === Number(categoryName);
          });

          return !currentAdminMenu
            ? `${categoryName} 카테고리 - SOOP`
            : `${currentAdminMenu.menuName} 콘텐츠 - SOOP`;
        }
      }

      if (routeList[0] === 'search') {
        return url[1] === 'hashtag' ? '태그 검색 - SOOP' : '통합 검색 - SOOP';
      }
      return `${SEO_TITLE[routeList[1]] || ''}SOOP`;
    } catch (error) {
      return 'SOOP';
    }
  }, [routeList, url, categoryMenu, route]);

  const handleLoadScript = (tagInfo) => {
    const existingScript = document.getElementById(tagInfo.id);
    // 존재한 스크립트가 있을 경우 다음
    if (existingScript) {
      return;
    }
    let isLoad = tagInfo.isLoad || false;
    let element = document.createElement(tagInfo.tag);
    // 중복 생성 방지를 위해 id 추가
    element.id = tagInfo.id;
    // 어트리 뷰트 있을경우 추가
    tagInfo.attribute &&
      tagInfo.attribute.filter((attribute) => {
        element[attribute.key] = attribute.value;
        return attribute;
      });
    document.head.appendChild(element);
    // head에 태그 추가
    // 로드함수 진행
    if (isLoad) {
      element.onload = () => {
        tagInfo.callback && tagInfo.callback();
      };
      element.onerror = () => {};
    }
  };

  useEffect(() => {
    // 선언된 만큼 tag 추가, dom 상태가 완료될때 수행 - in
    const handleReadyStateChange = () => {
      if (!isRender && document.readyState === 'complete') {
        DYNAMIC_TAG_LIST.map((tagInfo) => {
          if (
            loadedScriptsRef &&
            loadedScriptsRef.current &&
            loadedScriptsRef.current.has(tagInfo.id)
          ) {
            return;
          }
          loadedScriptsRef.current.add(tagInfo.id);
          handleLoadScript(tagInfo);
        });
        setIsRender(true);
      }
    };
    handleReadyStateChange();
    document.addEventListener('readystatechange', handleReadyStateChange);

    return () =>
      document.removeEventListener('readystatechange', handleReadyStateChange);
  }, [isRender]);

  return (
    <Helmet>
      <title>{helmetTitle}</title>
      <meta name='keyword' content={helmetKeyword} />
      <meta name='description' content={helmetDescription} />
      <meta property='og:type' content='website' />
      <script
        async={false}
        type='text/javascript'
        src={`${globalDomains.RES_AFREECATV}/script/new_main/common_pm.js`}></script>
    </Helmet>
  );
};

export default HelmetLoader;
